<template>
  <div class="auth-dialog-container">
    <!-- 登录/注册弹窗 (合并为一个弹框实现平滑切换) -->
    <el-dialog
      :visible.sync="authDialogVisible"
      width="720px"
      custom-class="auth-dialog"
      :show-close="false"
      center
      :before-close="handleAuthClose"
    >
      <div class="auth-wrap">
        <div class="auth-left">
          <img src="@/assets/new_picture/LOGO_b.png" alt="logo" class="logo-image">
          <div class="illustration"></div>
        </div>
        <div class="auth-right">
          <!-- 登录模式 -->
          <template v-if="authMode === 'login'">
            <div v-if="loginMode==='form'" class="auth-top">
              <div class="tabs">
                <span :class="{active: loginTab==='account'}" @click="loginTab='account'">账号登录</span>
                <span :class="{active: loginTab==='quick'}" @click="loginTab='quick'">快速登录</span>
              </div>
              <div class="qr-toggle" @click="toggleLoginMode">
                <i :class="loginMode==='qr' ? 'el-icon-user' : 'el-icon-qrcode'"></i>
                {{ loginMode==='qr' ? '账号登录' : '扫码登录更便捷' }}
                <img v-if="loginMode!=='qr'" src="@/assets/image/i_ma.png" alt="" class="ma-image">
              </div>
            </div>
            <div v-else class="qr-top">
              <div class="qr-top-action" @click="toggleLoginMode">账号登录</div>
            </div>

            <div v-if="loginMode==='form'" class="auth-form">
              <el-form :model="loginForm" :rules="loginRules" ref="loginForm" label-position="top">
                <el-form-item prop="mobile">
                  <el-input v-model="loginForm.mobile" placeholder="请输入手机号/邮箱" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item v-if="loginTab==='account'" prop="password">
                  <el-input v-model="loginForm.password" type="password" placeholder="请输入密码" show-password autocomplete="new-password"></el-input>
                  <div class="row-extra"><el-link type="primary" @click="handleForgotPassword">忘记密码</el-link></div>
                </el-form-item>
                <el-form-item v-else prop="code">
                  <el-input v-model="loginForm.code" placeholder="请输入验证码" autocomplete="off" @input="val => loginForm.code = val.replace(/[^\d]/g, '')">
                    <template slot="append">
                      <el-button size="mini" type="primary" :disabled="loginCodeSending || loginCodeCountdown>0" @click="sendLoginCode">{{ loginCodeCountdown>0 ? loginCodeCountdown + 's' : '获取验证码' }}</el-button>
                    </template>
                  </el-input>
                </el-form-item>
                <div class="agree-row">
                  <el-checkbox v-model="loginForm.agree">
                    我已阅读并同意
                    <a href="#" @click.prevent="openAgreementDialog('registration')">《注册协议》</a>
                    <a href="#" @click.prevent="openAgreementDialog('privacy')">《隐私政策》</a>
                  </el-checkbox>
                </div>
                <el-button type="primary" class="auth-submit" @click="handleLogin">登录</el-button>
                <div class="auth-bottom">没有账号？<a href="#" @click.prevent="switchToRegister">立即注册</a></div>
              </el-form>
            </div>

            <div v-else class="qr-login">
              <div class="qr-code-container" v-loading="wechatLoginLoading">
                <iframe v-if="wechatQrCodeUrl" :src="wechatQrCodeUrl" frameborder="0" allow="autoplay"></iframe>
                <div v-else-if="!wechatLoginLoading" class="qr-placeholder" @click="getWechatQr">
                  <i class="el-icon-refresh"></i>
                  <span>点击刷新二维码</span>
                </div>
              </div>
              <div class="qr-tip">请使用微信扫一扫登录</div>
              <!-- 隐藏：在浏览器中打开微信登录（二维码已内嵌 iframe，无需弹窗） -->
              <!-- <div class="qr-login-actions">
                <el-button size="mini" type="text" @click="openWechatLogin">在浏览器中打开微信登录</el-button>
              </div> -->
              <div class="qr-protocol">注册登录即代表同意《用户服务协议》《隐私政策》《会员服务协议》《授权许可协议》</div>
            </div>
          </template>

          <!-- 注册模式 -->
          <template v-else-if="authMode === 'register'">
            <div class="auth-top">
              <div class="auth-title">注册账号</div>
              <div class="qr-toggle" @click="switchToLoginQr">
                <i class="el-icon-qrcode"></i>
                扫码登录更便捷
                <img src="@/assets/image/i_ma.png" alt="" class="ma-image">
              </div>
            </div>
            <el-form :model="registerForm" :rules="registerRules" ref="registerForm" label-position="top" class="auth-form">
              <el-form-item prop="mobile">
                <el-input v-model="registerForm.mobile" placeholder="请输入手机号" maxlength="11" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item prop="code">
                <el-input v-model="registerForm.code" placeholder="请输入验证码" autocomplete="off">
                  <template slot="append">
                    <el-button size="mini" type="primary" :disabled="codeSending || codeCountdown>0" @click="sendCode">{{ codeCountdown>0 ? codeCountdown + 's' : '获取验证码' }}</el-button>
                  </template>
                </el-input>
              </el-form-item>
              <el-form-item prop="password">
                <el-input v-model="registerForm.password" type="password" placeholder="请输入6-20位登录密码" show-password autocomplete="new-password"></el-input>
              </el-form-item>
              <div class="agree-row">
                <el-checkbox v-model="registerForm.agree">
                  我已阅读并同意
                  <a href="#" @click.prevent="openAgreementDialog('registration')">《注册协议》</a>
                  <a href="#" @click.prevent="openAgreementDialog('privacy')">《隐私政策》</a>
                </el-checkbox>
              </div>
              <el-button type="primary" class="auth-submit" @click="handleRegister">注册</el-button>
              <div class="auth-bottom">已有账号？<a href="#" @click.prevent="switchToLogin">立即登录</a></div>
            </el-form>
          </template>
        </div>
      </div>
    </el-dialog>

    <!-- 找回密码弹窗 -->
    <el-dialog
      :visible.sync="showForgotDialog"
      width="720px"
      custom-class="login-dialog"
      :show-close="false"
      center
      :before-close="handleForgotClose"
    >
      <div class="auth-wrap">
        <div class="auth-left">
          <img src="@/assets/new_picture/LOGO_b.png" alt="logo" class="logo-image">
        </div>
        <div class="auth-right">
          <div class="auth-top">
            <div class="auth-title" style="text-align: left; padding-left: 0;">找回密码</div>
          </div>

          <div class="auth-form">
            <el-form ref="forgotForm" :model="forgotForm" :rules="forgotRules" label-position="top">
              <el-form-item prop="mobile">
                <el-input v-model="forgotForm.mobile" placeholder="请输入手机号" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item prop="code">
                <el-input v-model="forgotForm.code" placeholder="请输入验证码" autocomplete="off">
                  <template slot="append">
                    <el-button size="mini" type="primary" :disabled="forgotCodeSending || forgotCodeCountdown>0" @click="sendForgotCode">{{ forgotCodeCountdown>0 ? forgotCodeCountdown + 's' : '获取验证码' }}</el-button>
                  </template>
                </el-input>
              </el-form-item>
              <el-form-item prop="password">
                <el-input v-model="forgotForm.password" type="password" placeholder="请输入新密码" show-password autocomplete="new-password"></el-input>
              </el-form-item>
              <el-form-item prop="confirmPassword">
                <el-input v-model="forgotForm.confirmPassword" type="password" placeholder="请再次输入新密码" show-password autocomplete="new-password"></el-input>
              </el-form-item>

              <el-button type="primary" class="auth-submit" @click="handleResetPassword">确认重置</el-button>
              <div class="auth-bottom">想起密码？<a href="#" @click.prevent="switchToLoginFromForgot">立即登录</a></div>
            </el-form>
          </div>

          <i class="el-icon-close dialog-close" @click="handleForgotClose"></i>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="showWechatBindDialog"
      width="420px"
      custom-class="bind-dialog"
      :show-close="false"
      center
      :before-close="handleWechatBindClose"
    >
      <div class="bind-wrap">
        <div class="bind-title">绑定手机号</div>
        <div class="bind-subtitle">微信登录后需绑定手机号</div>
        <el-form ref="wechatBindForm" :model="wechatBindForm" :rules="wechatBindRules" label-position="top" class="bind-form">
          <el-form-item prop="mobile">
            <el-input v-model="wechatBindForm.mobile" placeholder="请输入手机号" maxlength="11" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item prop="code">
            <el-input v-model="wechatBindForm.code" placeholder="请输入验证码" autocomplete="off">
              <template slot="append">
                <el-button size="mini" type="primary" :disabled="wechatBindCodeSending || wechatBindCodeCountdown>0" @click="sendWechatBindCode">{{ wechatBindCodeCountdown>0 ? wechatBindCodeCountdown + 's' : '获取验证码' }}</el-button>
              </template>
            </el-input>
          </el-form-item>
          <el-button type="primary" class="bind-submit" :loading="wechatBindSubmitting" @click="handleWechatBind">绑定并登录</el-button>
        </el-form>
        <i class="el-icon-close dialog-close" @click="handleWechatBindClose"></i>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="showAgreementDialog"
      width="720px"
      custom-class="agreement-dialog"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
    >
      <div class="agreement-body">
        <el-tabs v-model="agreementActiveTab" class="agreement-tabs">
          <el-tab-pane label="注册协议" name="registration">
            <div class="agreement-scroll" v-html="registrationAgreementHtml"></div>
          </el-tab-pane>
          <el-tab-pane label="隐私政策" name="privacy">
            <div class="agreement-scroll" v-html="privacyAgreementHtml"></div>
          </el-tab-pane>
        </el-tabs>
        <div class="agreement-footer">
          <el-button type="primary" :disabled="agreementCountdown > 0" @click="acknowledgeAgreement">
            {{ agreementCountdown > 0 ? `已知晓(${agreementCountdown}s)` : '已知晓' }}
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getAgreementTemplate } from '@/api/authApi'
import { getWechatQrCode, getWechatLoginStatus } from '@/api/wechatApi'
// import request from '@/utils/request'
import { mapState } from 'vuex'

export default {
  name: 'AuthDialog',
  props: {
    showLogin: {
      type: Boolean,
      default: false
    },
    showRegister: {
      type: Boolean,
      default: false
    },
    checkRouteCode: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      authDialogVisible: this.showLogin || this.showRegister,
      authMode: this.showRegister ? 'register' : 'login',
      showForgotDialog: false,
      showWechatBindDialog: false,
      // 登录相关状态
      loginMode: 'form',
      loginTab: 'account',
      loginForm: { mobile: '', password: '', code: '', agree: false },
      loginRules: {
        mobile: [
          { required: true, message: '请输入手机号/邮箱', trigger: 'blur' }
        ],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      },
      loginCodeCountdown: 0,
      loginCodeSending: false,
      loginCodeTimer: null,
      // 注册相关状态
      registerForm: { mobile: '', code: '', password: '', agree: false },
      registerRules: {
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }
        ],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, max: 20, message: '6-20位字符', trigger: 'blur' }
        ]
      },
      codeCountdown: 0,
      codeSending: false,
      codeTimer: null,
      forgotForm: { mobile: '', code: '', password: '', confirmPassword: '' },
      forgotRules: {
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }
        ],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
        password: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, max: 20, message: '6-20位字符', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value !== this.forgotForm.password) {
                callback(new Error('两次输入密码不一致'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ]
      },
      forgotCodeCountdown: 0,
      forgotCodeSending: false,
      forgotCodeTimer: null,
      wechatLoginLoading: false,
      lastWechatCodeHandled: '',
      wechatBindForm: { mobile: '', code: '' },
      wechatBindRules: {
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }
        ],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      },
      wechatBindCodeCountdown: 0,
      wechatBindCodeSending: false,
      wechatBindCodeTimer: null,
      wechatBindSubmitting: false,
      registerAgreementTemplate: null,
      privacyAgreementTemplate: null,
      showAgreementDialog: false,
      agreementActiveTab: 'registration',
      agreementCountdown: 0,
      agreementTimer: null,
      agreementCountdownSeconds: 5,
      privacyPolicyFallbackHtml:
        '<h2>隐私政策</h2><p>我们非常重视用户隐私保护，严格遵守相关法律法规，确保用户个人信息的安全与保密。</p><h3>信息收集</h3><p>当您注册账户、购买课程、参加活动或联系我们时，您可能需要提供个人基本信息、账户信息等。</p><h3>信息使用</h3><p>我们可能将收集到的信息用于提供和维护服务、处理订单与请求、改进产品体验等。</p><h3>信息保护</h3><p>我们采取加密、访问控制等措施保护您的个人信息安全。</p><h3>您的权利</h3><p>您有权访问、更正、删除个人信息，并可依法行使撤回同意等权利。</p>',
      wechatQrCodeUrl: '',
      wechatSceneId: '',
      wechatState: '',
      wechatPollTimer: null,
      wechatExpireTimer: null,
      wechatWindowCheckTimer: null,
      wechatLoginStatus: 'pending',
      wechatExpireSeconds: 600
    }
  },
  created() {
    this._wechatLoginWindow = null
  },
  mounted() {
    this.handleWechatCallback()
    this.handleWechatLoginRedirect()
    this._onWechatMessage = (e) => {
      if (e && e.data && e.data.type === 'wechat_login_success' && e.data.sceneId) {
        this.wechatSceneId = e.data.sceneId
        this.startWechatPoll()
      }
    }
    window.addEventListener('message', this._onWechatMessage)
    if (this.isLoggedIn) {
      this.authDialogVisible = false
      this.$emit('close-login')
      this.$emit('close-register')
    }
  },
  beforeDestroy() {
    if (this._onWechatMessage) {
      window.removeEventListener('message', this._onWechatMessage)
      this._onWechatMessage = null
    }
    if (this.loginCodeTimer) clearInterval(this.loginCodeTimer)
    if (this.codeTimer) clearInterval(this.codeTimer)
    if (this.forgotCodeTimer) clearInterval(this.forgotCodeTimer)
    if (this.wechatBindCodeTimer) clearInterval(this.wechatBindCodeTimer)
    if (this.wechatWindowCheckTimer) {
      clearInterval(this.wechatWindowCheckTimer)
      this.wechatWindowCheckTimer = null
    }
    if (this.agreementTimer) {
      clearInterval(this.agreementTimer)
      this.agreementTimer = null
    }
    this.stopWechatPoll()
      // // this.closeWechatLoginWindow()
    },
    computed: {
    ...mapState('auth', ['isLoggedIn']),
    registrationAgreementHtml() {
      return (this.registerAgreementTemplate && this.registerAgreementTemplate.templateContent) || '暂无协议内容'
    },
    privacyAgreementHtml() {
      const html = this.privacyAgreementTemplate && this.privacyAgreementTemplate.templateContent
      return html || this.privacyPolicyFallbackHtml || '暂无隐私政策内容'
    }
  },
  watch: {
    showLogin(newVal) {
      if (newVal) {
        this.authDialogVisible = true
        this.authMode = 'login'
        if (this.$refs.loginForm) this.$refs.loginForm.resetFields()
        this.loginForm = { mobile: '', password: '', code: '', agree: false }
        this.loginTab = 'account'
        this.loginMode = 'form'
      }
    },
    showRegister(newVal) {
      if (newVal) {
        this.authDialogVisible = true
        this.authMode = 'register'
        if (this.$refs.registerForm) this.$refs.registerForm.resetFields()
        this.registerForm = { mobile: '', code: '', password: '', agree: false }
      }
    },
    authDialogVisible(newVal) {
      if (!newVal) {
        this.$emit('close-login')
        this.$emit('close-register')
        this.stopWechatPoll()
        // this.closeWechatLoginWindow()
      }
    },
    showForgotDialog(newVal) {
      if (newVal) {
        if (this.$refs.forgotForm) this.$refs.forgotForm.resetFields()
        this.forgotForm = { mobile: '', code: '', password: '', confirmPassword: '' }
      }
    },
    showWechatBindDialog(newVal) {
      if (newVal) {
        if (this.$refs.wechatBindForm) this.$refs.wechatBindForm.resetFields()
        this.wechatBindForm = { mobile: '', code: '' }
      }
    },
    '$route.query.code'() {
      this.handleWechatCallback()
    },
    // 监听登录状态，有token时关闭所有弹窗
    isLoggedIn(newVal) {
      if (newVal) {
        this.authDialogVisible = false;
        this.showForgotDialog = false;
        this.showWechatBindDialog = false;
      }
    },
    showAgreementDialog(next) {
      if (!next) {
        if (this.agreementTimer) {
          clearInterval(this.agreementTimer)
          this.agreementTimer = null
        }
        this.agreementCountdown = 0
      }
    }
  },
  methods: {
    toggleLoginMode() {
      this.loginMode = this.loginMode === 'form' ? 'qr' : 'form'
      if (this.loginMode === 'qr') {
        this.getWechatQr()
      }
    },
    handleLogin() {
      if (!this.loginForm.agree) {
        this.$message.error('请阅读并同意注册协议与隐私政策')
        return
      }
      this.$refs.loginForm.validate(valid => {
        if (!valid) return
        const payload = {
          phone: this.loginForm.mobile,
          password: this.loginTab === 'account' ? this.loginForm.password : '',
          smsCode: this.loginTab === 'quick' ? this.loginForm.code : '',
          loginType: this.loginTab === 'account' ? 'password' : 'sms'
        }
        this.$store.dispatch('auth/login', payload).then(async res => {
          this.$message.success('登录成功')
          await this.syncPersonalInfo()
          this.$emit('login-success', {
            phone: this.loginForm.mobile,
            username: res && res.data && res.data.username
          })
          if (typeof window !== 'undefined') {
            window.dispatchEvent(new Event('auth:login-success'))
          }
        }).catch(err => {
          this.$message.error((err && err.message) || '登录失败')
        })
      })
    },
    handleAuthClose() {
      this.stopWechatPoll()
      // this.closeWechatLoginWindow()
      if (this.loginCodeTimer) {
        clearInterval(this.loginCodeTimer)
        this.loginCodeTimer = null
      }
      this.loginCodeCountdown = 0
      this.loginCodeSending = false
      if (this.codeTimer) {
        clearInterval(this.codeTimer)
        this.codeTimer = null
      }
      this.codeCountdown = 0
      this.codeSending = false
      if (this.$refs.loginForm) this.$refs.loginForm.resetFields()
      if (this.$refs.registerForm) this.$refs.registerForm.resetFields()
      this.authDialogVisible = false
    },
    async syncPersonalInfo() {
      // 暂时不调用个人信息接口，避免报错导致重新登录
      return null
      /*
      try {
        const res = await request({
          url: 'http://192.168.1.9:8080/api/frontend/personal/info',
          method: 'get'
        })
        const data = (res && res.data) || null
        if (data && this.$store && this.$store.dispatch) {
          await this.$store.dispatch('auth/updateUserInfo', data)
        }
        return data
      } catch (err) {
        return null
      }
      */
    },
    // 验证码倒计时方法
    sendCode() {
      const reg = /^1[3-9]\d{9}$/
      if (!reg.test(this.registerForm.mobile)) {
        this.$message.error('请输入正确的手机号')
        return
      }
      if (this.codeCountdown > 0 || this.codeSending) return
      this.codeSending = true
      this.$store.dispatch('auth/checkPhoneRegistered', { phone: this.registerForm.mobile }).then(registered => {
        if (registered) {
          this.codeSending = false
          this.$message.warning('手机号已注册，请直接登录')
          this.switchToLogin()
          return
        }
        return this.$store.dispatch('auth/sendRegisterSmsCode', { phone: this.registerForm.mobile, skipPhoneCheck: true }).then(() => {
          this.$message.success('验证码已发送')
          this.codeCountdown = 60
          this.codeTimer = setInterval(() => {
            if (this.codeCountdown <= 1) {
              clearInterval(this.codeTimer)
              this.codeTimer = null
              this.codeCountdown = 0
              this.codeSending = false
            } else {
              this.codeCountdown -= 1
            }
          }, 1000)
        })
      }).catch(() => {
        this.codeSending = false
      })
    },
    sendLoginCode() {
      const reg = /^1[3-9]\d{9}$/
      if (!reg.test(this.loginForm.mobile)) {
        this.$message.error('请输入正确的手机号')
        return
      }
      if (this.loginCodeCountdown > 0 || this.loginCodeSending) return
      this.loginCodeSending = true
      this.$store.dispatch('auth/sendLoginSmsCode', { phone: this.loginForm.mobile }).then(() => {
        this.$message.success('验证码已发送')
        this.loginCodeCountdown = 60
        this.loginCodeTimer = setInterval(() => {
          if (this.loginCodeCountdown <= 1) {
            clearInterval(this.loginCodeTimer)
            this.loginCodeTimer = null
            this.loginCodeCountdown = 0
            this.loginCodeSending = false
          } else {
            this.loginCodeCountdown -= 1
          }
        }, 1000)
      }).catch(() => {
        this.loginCodeSending = false
      })
    },
    // 登录模式切换
    switchToLoginQr() {
      this.authMode = 'login'
      this.loginMode = 'qr'
      this.getWechatQr()
    },
    /**
     * 处理微信登录回调
     * 验证 state 参数防止 CSRF 攻击
     */
    async handleWechatCallback() {
      const code = this.$route.query.code
      const state = this.$route.query.state
      
      if (!code) return
      
      // 防止重复处理同一个 code
      if (this.lastWechatCodeHandled === code) return
      this.lastWechatCodeHandled = code
      
      // 验证 state 参数
      if (state) {
        const savedState = sessionStorage.getItem('wechat_login_state')
        if (savedState && savedState !== state) {
          console.warn('微信登录回调 state 参数验证失败，可能存在 CSRF 攻击')
          this.$message.error('登录验证失败，请重新登录')
          this.clearWechatCodeFromUrl()
          return
        }
        // 验证成功后清除保存的 state
        sessionStorage.removeItem('wechat_login_state')
      }
      
      // 清除 URL 中的 code 和 state 参数
      this.clearWechatCodeFromUrl()
    },
    /**
     * 处理从微信回调顶层跳转回来的场景
     * URL 形如 /?wechat_login=1&sceneId=xxx
     */
    handleWechatLoginRedirect() {
      const q = this.$route.query
      if (q.wechat_login !== '1') return
      const sceneId = q.sceneId || ''
      // 清除 URL 参数
      this.$router.replace({ query: {} }).catch(() => {})
      // 打开登录弹框并恢复扫码登录流程
      this.authDialogVisible = true
      this.authMode = 'login'
      this.loginMode = 'qr'
      if (sceneId) {
        this.wechatSceneId = sceneId
        this.startWechatPoll()
      }
    },
    clearWechatCodeFromUrl() {
      if (this.$route.query.code || this.$route.query.state) {
        this.$router.replace({ query: {} }).catch(() => {})
      }
    },
    // 隐藏：不再弹出微信登录窗口，二维码已内嵌 iframe
    // openWechatLogin() {
    //   if (!this.wechatQrCodeUrl) return
    //   if (this._wechatLoginWindow) {
    //     try {
    //       if (!this._wechatLoginWindow.closed) {
    //         this._wechatLoginWindow.close()
    //       }
    //     } catch (e) {
    //       try {
    //         this._wechatLoginWindow.close()
    //       } catch (closeError) {
    //         void closeError
    //       }
    //     }
    //   }
    //   const width = 600
    //   const height = 700
    //   const left = (window.screen.width - width) / 2
    //   const top = (window.screen.height - height) / 2
    //   const newWindow = window.open(
    //     this.wechatQrCodeUrl,
    //     'wechatLoginWindow',
    //     `width=${width},height=${height},left=${left},top=${top},scrollbars=yes,resizable=yes`
    //   )
    //   this._wechatLoginWindow = newWindow
    //   if (this.wechatWindowCheckTimer) {
    //     clearInterval(this.wechatWindowCheckTimer)
    //     this.wechatWindowCheckTimer = null
    //   }
    //   if (this._wechatLoginWindow) {
    //     this.wechatWindowCheckTimer = setInterval(() => {
    //       try {
    //         if (this._wechatLoginWindow && this._wechatLoginWindow.closed) {
    //           this._wechatLoginWindow = null
    //           clearInterval(this.wechatWindowCheckTimer)
    //           this.wechatWindowCheckTimer = null
    //         }
    //       } catch (e) {
    //         this._wechatLoginWindow = null
    //         clearInterval(this.wechatWindowCheckTimer)
    //         this.wechatWindowCheckTimer = null
    //       }
    //     }, 500)
    //   }
    // },
    // closeWechatLoginWindow() {
    //   if (!this._wechatLoginWindow) return
    //   try {
    //     if (!this._wechatLoginWindow.closed) {
    //       this._wechatLoginWindow.close()
    //     }
    //   } catch (e) {
    //     try {
    //       this._wechatLoginWindow.close()
    //     } catch (closeError) {
    //       void closeError
    //     }
    //   }
    //   this._wechatLoginWindow = null
    //   if (this.wechatWindowCheckTimer) {
    //     clearInterval(this.wechatWindowCheckTimer)
    //     this.wechatWindowCheckTimer = null
    //   }
    // },
    /**
     * 获取微信登录二维码
     * 适配微信登录体系
     */
    async getWechatQr() {
      this.stopWechatPoll()
      this.clearWechatExpireTimer()
      // // this.closeWechatLoginWindow()
      this.wechatLoginLoading = true
      this.wechatLoginStatus = 'pending'
      this.wechatQrCodeUrl = ''
      this.wechatSceneId = ''
      this.wechatState = ''
      
      try {
        // 调用接口获取二维码（不需要传参数）
        const res = await getWechatQrCode()
        
        if (res && res.data) {
          // 保存 sceneId 用于轮询登录状态
          this.wechatSceneId = res.data.sceneId || ''
          
          // 保存 state 参数用于回调验证
          if (res.data.state) {
            this.wechatState = res.data.state
            // 将 state 存储到 sessionStorage，用于回调时验证
            sessionStorage.setItem('wechat_login_state', res.data.state)
          }
          
          // 处理二维码 URL，修复可能的 URL 格式问题
          let url = (res.data.qrCodeUrl || '').trim()
          if (url) {
            // 修复 URL 中可能存在的格式错误
            while (url.includes('http://https://')) {
              url = url.replace('http://https://', 'https://')
            }
            while (url.includes('http%3A%2F%2Fhttps%3A%2F%2F')) {
              url = url.replace('http%3A%2F%2Fhttps%3A%2F%2F', 'https%3A%2F%2F')
            }
            this.wechatQrCodeUrl = url
          }
          
          // 设置过期时间
          this.wechatExpireSeconds = res.data.expireSeconds || 600
          
          // 隐藏：不再弹出微信登录窗口，二维码已内嵌 iframe
          // this.openWechatLogin()
          this.startWechatExpireTimer()
          this.startWechatPoll()
        } else {
          this.$message.error('获取二维码失败：返回数据格式错误')
        }
      } catch (err) {
        const errorMsg = (err && err.message) || '获取登录链接失败'
        this.$message.error(errorMsg)
        console.error('获取微信登录二维码失败:', err)
      } finally {
        this.wechatLoginLoading = false
      }
    },
    stopWechatPoll() {
      if (this.wechatPollTimer) {
        clearInterval(this.wechatPollTimer)
        this.wechatPollTimer = null
      }
    },
    clearWechatExpireTimer() {
      if (this.wechatExpireTimer) {
        clearInterval(this.wechatExpireTimer)
        this.wechatExpireTimer = null
      }
    },
    startWechatExpireTimer() {
      this.clearWechatExpireTimer()
      this.wechatExpireTimer = setInterval(() => {
        if (this.wechatExpireSeconds > 0) {
          this.wechatExpireSeconds--
        } else {
          this.clearWechatExpireTimer()
          this.stopWechatPoll()
          // this.closeWechatLoginWindow()
          this.$message.warning('二维码已过期，请重新获取')
        }
      }, 1000)
    },
    startWechatPoll() {
      this.stopWechatPoll()
      if (!this.wechatSceneId) return
      
      this.wechatPollTimer = setInterval(async () => {
        if (!this.authDialogVisible) {
          this.stopWechatPoll()
          return
        }

        try {
          const res = await getWechatLoginStatus(this.wechatSceneId)
          const data = res && res.data
          if (!data) return

          this.wechatLoginStatus = data.status

          if (data.status === 'success') {
            this.stopWechatPoll()
            this.clearWechatExpireTimer()
            // this.closeWechatLoginWindow()
            
            // 重置验证码倒计时
            if (this.loginCodeTimer) {
              clearInterval(this.loginCodeTimer)
              this.loginCodeTimer = null
            }
            this.loginCodeCountdown = 0
            this.loginCodeSending = false
            
            if (data.needBindPhone) {
              if (data.tempToken) {
                this.$store.commit('auth/SET_WECHAT_TEMP_TOKEN', data.tempToken)
              }
              this.authDialogVisible = false
              this.showWechatBindDialog = true
              this.wechatBindForm.mobile = ''
              this.wechatBindForm.code = ''
              
              if (data.wechatPhone) {
                // 如果有微信手机号，可以自动填充或处理，这里暂且保留手动绑定逻辑
                this.wechatBindForm.mobile = data.wechatPhone
              }
              return
            }
            
            // 优先使用 loginResponse 中的信息
            const loginInfo = data.loginResponse || {}
            const token = loginInfo.token || data.token
            
            if (token) {
              localStorage.setItem('token', token)
              this.$store.commit('auth/SET_LOGIN_STATUS', true)
              
              // 如果有用户信息，保存到 store 和 localStorage
              if (loginInfo.username || loginInfo.phone || loginInfo.userInfo) {
                const userInfo = loginInfo.userInfo || {
                  username: loginInfo.username || data.username || '',
                  phone: loginInfo.phone || '',
                  ...loginInfo
                }
                localStorage.setItem('userInfo', JSON.stringify(userInfo))
                this.$store.commit('auth/SET_USER_INFO', userInfo)
                if (userInfo.username || userInfo.realName || userInfo.nickname) {
                  this.$store.commit('auth/SET_USERNAME', userInfo.username || userInfo.realName || userInfo.nickname)
                }
              }
            }
            
            this.$message.success('登录成功')
            this.authDialogVisible = false
            this.showWechatBindDialog = false
            await this.syncPersonalInfo()
            this.$emit('login-success', {
              phone: loginInfo.phone || '',
              username: loginInfo.username || data.username || ''
            })
            if (typeof window !== 'undefined') {
              window.dispatchEvent(new Event('auth:login-success'))
            }
            this.clearWechatCodeFromUrl()
          } else if (data.status === 'expired') {
            this.stopWechatPoll()
            this.clearWechatExpireTimer()
            this.wechatExpireSeconds = 0
            // this.closeWechatLoginWindow()
          }
        } catch (err) {
          console.error('Poll status error', err)
        }
      }, 2000)
},
    handleForgotClose() {
      if (this.forgotCodeTimer) {
        clearInterval(this.forgotCodeTimer)
        this.forgotCodeTimer = null
      }
      this.forgotCodeCountdown = 0
      this.forgotCodeSending = false
      if (this.$refs.forgotForm) this.$refs.forgotForm.resetFields()
      this.showForgotDialog = false
      this.authDialogVisible = true
      this.authMode = 'login'
    },
    handleForgotPassword() {
      this.authDialogVisible = false
      this.showForgotDialog = true
    },
    handleWechatBindClose() {
      if (this.wechatBindCodeTimer) {
        clearInterval(this.wechatBindCodeTimer)
        this.wechatBindCodeTimer = null
      }
      this.wechatBindCodeCountdown = 0
      this.wechatBindCodeSending = false
      if (this.$refs.wechatBindForm) this.$refs.wechatBindForm.resetFields()
      this.showWechatBindDialog = false
    },
    sendWechatBindCode() {
      const reg = /^1[3-9]\d{9}$/
      if (!reg.test(this.wechatBindForm.mobile)) {
        this.$message.error('请输入正确的手机号')
        return
      }
      if (this.wechatBindCodeCountdown > 0 || this.wechatBindCodeSending) return
      this.wechatBindCodeSending = true
      this.$store.dispatch('auth/sendWechatBindPhoneSmsCode', { phone: this.wechatBindForm.mobile }).then(() => {
        this.$message.success('验证码已发送')
        this.wechatBindCodeCountdown = 60
        this.wechatBindCodeTimer = setInterval(() => {
          if (this.wechatBindCodeCountdown <= 1) {
            clearInterval(this.wechatBindCodeTimer)
            this.wechatBindCodeTimer = null
            this.wechatBindCodeCountdown = 0
            this.wechatBindCodeSending = false
          } else {
            this.wechatBindCodeCountdown -= 1
          }
        }, 1000)
      }).catch(() => {
        this.wechatBindCodeSending = false
      })
    },
    handleWechatBind() {
      if (this.wechatBindSubmitting) return
      this.$refs.wechatBindForm.validate(async valid => {
        if (!valid) return
        this.wechatBindSubmitting = true
        try {
          const res = await this.$store.dispatch('auth/wechatBindPhone', {
            phone: this.wechatBindForm.mobile,
            smsCode: this.wechatBindForm.code
          })
          
          // 使用返回的登录信息
          const loginData = (res && res.data) || {}
          const userInfo = loginData.userInfo || {}
          
          this.$message.success('登录成功')
          this.stopWechatPoll()
          this.showWechatBindDialog = false
          this.authDialogVisible = false
          this.$emit('login-success', {
            phone: userInfo.phone || loginData.phone || this.wechatBindForm.mobile,
            username: userInfo.username || loginData.username || ''
          })
          if (typeof window !== 'undefined') {
            window.dispatchEvent(new Event('auth:login-success'))
          }
          this.clearWechatCodeFromUrl()
          if (typeof window !== 'undefined') {
            window.location.reload()
          }
        } catch (err) {
          this.$message.error((err && err.message) || '绑定失败')
        } finally {
          this.wechatBindSubmitting = false
        }
      })
    },
    sendForgotCode() {
      const reg = /^1[3-9]\d{9}$/
      if (!reg.test(this.forgotForm.mobile)) {
        this.$message.error('请输入正确的手机号')
        return
      }
      if (this.forgotCodeCountdown > 0 || this.forgotCodeSending) return
      this.forgotCodeSending = true
      this.$store.dispatch('auth/sendForgotPasswordSmsCode', { phone: this.forgotForm.mobile }).then(() => {
        this.$message.success('验证码已发送')
        this.forgotCodeCountdown = 60
        this.forgotCodeTimer = setInterval(() => {
          if (this.forgotCodeCountdown <= 1) {
            clearInterval(this.forgotCodeTimer)
            this.forgotCodeTimer = null
            this.forgotCodeCountdown = 0
            this.forgotCodeSending = false
          } else {
            this.forgotCodeCountdown -= 1
          }
        }, 1000)
      }).catch(() => {
        this.forgotCodeSending = false
      })
    },
    handleResetPassword() {
      this.$refs.forgotForm.validate(async valid => {
        if (!valid) return
        try {
          await this.$store.dispatch('auth/resetPassword', {
            phone: this.forgotForm.mobile,
            smsCode: this.forgotForm.code,
            newPassword: this.forgotForm.password
          })
          this.$message.success('重置成功，请使用新密码登录')
          const mobile = this.forgotForm.mobile
          this.showForgotDialog = false
          this.authDialogVisible = true
          this.authMode = 'login'
          this.loginMode = 'form'
          this.loginTab = 'account'
          this.loginForm.mobile = mobile
          this.loginForm.password = ''
          this.loginForm.code = ''
        } catch (err) {
          this.$message.error((err && err.message) || '重置失败')
        }
      })
    },
    switchToLoginFromForgot() {
      const mobile = this.forgotForm.mobile
      this.showForgotDialog = false
      this.authDialogVisible = true
      this.authMode = 'login'
      this.loginMode = 'form'
      this.loginTab = 'account'
      this.loginForm.mobile = mobile
      this.loginForm.password = ''
      this.loginForm.code = ''
    },

    // 切换登录/注册
    switchToLogin() {
      this.authMode = 'login'
      this.loginMode = 'form'
      this.loginTab = 'account'
      if (this.$refs.loginForm) this.$refs.loginForm.resetFields()
      this.loginForm = { mobile: '', password: '', code: '', agree: false }
    },
    switchToRegister() {
      this.authMode = 'register'
      if (this.$refs.registerForm) this.$refs.registerForm.resetFields()
      this.registerForm = { mobile: '', code: '', password: '', agree: false }
    },

    // 注册相关方法
    handleRegister() {
      if (!this.registerForm.agree) {
        this.$message.error('请阅读并同意注册协议与隐私政策')
        return
      }
      this.$refs.registerForm.validate(valid => {
        if (!valid) return
        this.$store.dispatch('auth/checkPhoneRegistered', { phone: this.registerForm.mobile }).then(registered => {
          if (registered) {
            this.$message.warning('账号已存在，请直接登录')
            this.switchToLogin()
            return
          }
          const payload = {
            phone: this.registerForm.mobile,
            password: this.registerForm.password,
            smsCode: this.registerForm.code,
            skipPhoneCheck: true
          }
          return this.$store.dispatch('auth/register', payload).then(async res => {
            await this.syncPersonalInfo()
            this.$message.success('注册成功')
            this.authDialogVisible = false
            this.$emit('register-success', {
              phone: this.registerForm.mobile,
              username: res && res.data && res.data.username
            })
            if (typeof window !== 'undefined') {
              window.dispatchEvent(new Event('auth:login-success'))
            }
          })
        }).catch(err => {
          this.$message.error((err && err.message) || '注册失败')
        })
      })
    },

    async loadRegisterAgreement() {
      try {
        const res = await getAgreementTemplate('REGISTRATION_AGREEMENT')
        if (res && res.code === 200) {
          this.registerAgreementTemplate = res.data || null
        }
      } catch (err) {
        console.error(err)
      }
    },

    async loadPrivacyAgreement() {
      if (this.privacyAgreementTemplate) return
      try {
        const res = await getAgreementTemplate('PRIVACY_POLICY')
        if (res && res.code === 200) {
          this.privacyAgreementTemplate = res.data || null
        }
      } catch (err) {
        void err
      }
    },

    async openAgreementDialog(tab) {
      const nextTab = tab === 'privacy' ? 'privacy' : 'registration'
      this.agreementActiveTab = nextTab
      this.showAgreementDialog = true

      if (!this.registerAgreementTemplate) {
        await this.loadRegisterAgreement()
      }
      await this.loadPrivacyAgreement()

      if (this.agreementTimer) {
        clearInterval(this.agreementTimer)
        this.agreementTimer = null
      }
      this.agreementCountdown = Number(this.agreementCountdownSeconds) || 5
      this.agreementTimer = setInterval(() => {
        if (this.agreementCountdown <= 1) {
          this.agreementCountdown = 0
          clearInterval(this.agreementTimer)
          this.agreementTimer = null
          return
        }
        this.agreementCountdown -= 1
      }, 1000)
    },

    acknowledgeAgreement() {
      if (this.agreementCountdown > 0) return
      this.showAgreementDialog = false
      this.registerForm.agree = true
      this.loginForm.agree = true
    }
  }
}
</script>

<style lang="scss">
/* 登录/注册弹框样式 */
.auth-dialog {
  border-radius: 12px;
  box-shadow: 0 20px 60px rgba(0,0,0,.25);
  
  .el-dialog__header {
    display:none;
  }
  
  .el-dialog__body {
    padding: 0;
  }
}

.agreement-dialog {
  border-radius: 12px;
  box-shadow: 0 20px 60px rgba(0,0,0,.25);

  .el-dialog__body {
    padding: 0;
  }
}

.agreement-body {
  height: 60vh;
  display: flex;
  flex-direction: column;
  background: #fff;
}

.agreement-tabs {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;

  .el-tabs__header {
    margin-bottom: 0;
  }

  .el-tabs__nav-wrap {
    padding: 0 24px;
  }

  .el-tabs__nav-scroll {
    overflow: hidden;
  }

  .el-tabs__nav {
    display: flex;
    justify-content: center;
  }

  .el-tabs__item {
    padding: 0 20px;
    font-size: 16px;
    font-weight: 600;
    color: #606266;
    height: 48px;
    line-height: 48px;
    flex-shrink: 0;
    max-width: 50%;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    &.is-active {
      color: #3E2CCD;
    }

    &:hover {
      color: #3E2CCD;
    }
  }

  .el-tabs__active-bar {
    background-color: #3E2CCD;
  }

  .el-tabs__content {
    flex: 1;
    overflow: hidden;
  }

  .el-tab-pane {
    height: 100%;
  }
}

.agreement-scroll {
  height: 100%;
  overflow: auto;
  padding: 0 24px 16px;
  color: #333;
  font-size: 14px;
  line-height: 1.8;

  h1, h2, h3, h4 {
    margin: 16px 0 8px;
  }

  p {
    margin: 0 0 10px;
  }

  ul, ol {
    padding-left: 20px;
    margin: 0 0 10px;
  }
}

.agreement-footer {
  padding: 12px 24px 16px;
  display: flex;
  justify-content: center;
  border-top: 1px solid #eee;
  background: #fff;
}

.auth-wrap {
  display:flex;
  background:#fff;
  border-radius:12px;
  overflow:hidden;
  position: relative;
}

.auth-left {
  width: 320px;
  background: url('~@/assets/image/l_pic00.png') center/cover no-repeat;
  color:#303133;
  display:flex;
  flex-direction:column;
  align-items:center;
  justify-content:flex-start;
  padding-top: 80px;
}

.auth-left .logo-image {
  width: 180px;
  margin-top: -40px;
  margin-bottom: 12px;
}
.auth-right {
  flex: 1;
  position:relative;
  padding: 32px 40px;
}


.auth-top {
  display:flex;
  align-items:center;
  justify-content:space-between;
  margin-bottom: 12px;
}

.auth-title {
  font-size: 18px;
  font-weight: 600;
}

.auth-form {
  min-height: 280px;
}

.auth-form .el-form-item {
  margin-bottom: 24px;
}

.agree-row {
  font-size: 12px;
  color:#606266;
  margin: 6px 0 12px;
}

.auth-submit {
  width: 100%;
  margin-bottom: 8px;
  border-radius: 8px;
  height: 40px;
}

.auth-bottom {
  margin-top: 8px;
  font-size: 12px;
  color:#606266;
  text-align: center;
}

.dialog-close {
  position:absolute;
  top: 10px;
  right: 10px;
  font-size: 18px;
  color:#909399;
  cursor:pointer;
}

.qr-top {
  position: relative;
  height: 24px;
}

.qr-top-action {
  position: absolute;
  top: 0;
  right: 0;
  font-size: 12px;
  color: #3E2CCD;
  cursor: pointer;
  padding: 2px 0;
}

.tabs span {
  margin-right: 16px;
  cursor: pointer;
  font-weight: 600;
  color:#606266;
  padding: 6px 0;
  border-bottom: 2px solid transparent;
}

.tabs span.active {
  color:#3E2CCD;
  border-bottom-color: #3E2CCD;
}

.qr-toggle {
  font-size: 12px;
  color:#3E2CCD;
  cursor:pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.ma-image {
  width: 14px;
  height: 14px;
  display: inline-block;
}

.row-extra {
  text-align: right;
  margin-top: 6px;
}

.qr-login {
  text-align: center;
  padding: 14px 0 0;
}

.qr-login-btn {
  width: 100%;
  margin-top: 10px;
  border-radius: 8px;
  height: 40px;
}

.qr-login-actions {
  margin-top: 10px;
  font-size: 12px;
}

.bind-dialog {
  border-radius: 12px;
  box-shadow: 0 20px 60px rgba(0,0,0,.25);

  .el-dialog__header {
    display:none;
  }

  .el-dialog__body {
    padding: 0;
  }
}

.bind-wrap {
  background: #fff;
  border-radius: 12px;
  padding: 24px 24px 20px;
  position: relative;
}

.bind-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
}

.bind-subtitle {
  margin-top: 6px;
  font-size: 12px;
  color: #909399;
}

.bind-form {
  margin-top: 16px;
}

.bind-submit {
  width: 100%;
  height: 40px;
  border-radius: 8px;
}

.qr-box {
  margin: 16px auto 12px;
  width: 300px;
  height: 300px;
  border: 1px solid rgba(62, 44, 205, 0.6);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.qr-code-container {
  margin: 16px auto 12px;
  width: 300px;
  height: 300px;
  //border: 1px solid rgba(62, 44, 205, 0.6);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.qr-code-container .qr-code-image {
  width: 200px;
  height: 200px;
  object-fit: contain;
}

.qr-code-container .qr-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: #909399;
}

.qr-code-container .qr-placeholder i {
  font-size: 40px;
  cursor: pointer;
  color: #409eff;
}

.qr-code-container .qr-placeholder i:hover {
  color: #66b1ff;
}

.qr-code-container iframe {
  width: 380px;
  height: 380px;
  transform: scale(0.79);
  transform-origin: center center;
}

.qr-placeholder {
  width: 180px;
  height: 180px;
  background: #fff;
  border-radius: 2px;
  border: 1px solid #ebeef5;
}

.qr-title {
  font-size: 18px;
  font-weight: 700;
  color: #3E2CCD;
  margin-top: 10px;
}

.qr-tip {
  font-size: 12px;
  color: #606266;
  margin-bottom: 10px;
}

.qr-protocol {
  font-size: 12px;
  color: #909399;
  padding: 0 12px;
  line-height: 1.5;
}

.login-dialog,
.register-dialog {
  ::v-deep .el-input__inner {
    border-radius: 8px;
    height: 40px;
    line-height: 40px;
    border-color: #cfd3dc;
  }

  ::v-deep .el-input__inner:focus {
    border-color: #3E2CCD;
  }

  ::v-deep .el-button--primary {
    background-color: #3E2CCD;
    border-color: #3E2CCD;
  }

  ::v-deep .el-button--primary.is-disabled,
  ::v-deep .el-button--primary.is-disabled:hover,
  ::v-deep .el-button--primary.is-disabled:focus,
  ::v-deep .el-button--primary.is-disabled:active {
    background-color: rgba(62, 44, 205, 0.5);
    border-color: rgba(62, 44, 205, 0.5);
  }

  ::v-deep .el-input-group__append {
    border: none;
    background: transparent;
    padding: 0;
  }

  ::v-deep .el-input-group__append .el-button {
    border-radius: 0 8px 8px 0;
    height: 40px;
    margin: 0;
    padding: 0 14px;
  }
}

/* 响应式布局 */
@media (max-width: 720px) {
  .auth-wrap {
    flex-direction: column;
  }
  
  .auth-left {
    width: 100%;
  }
}
</style>
